// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mg-btn[data-v-04083b58]{width:76px;height:42px;display:flex;justify-content:center;align-items:center;padding:10.5px 24px;border-radius:6px;background:var(--m-color-gray-200);font-size:14px;font-weight:600;line-height:21px;text-align:center;color:var(--m-color-text-highlight);cursor:pointer}.mg-btn.mg-btn-primary[data-v-04083b58]{background:#3662ec;color:#fff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
